export const scrollToTop = () => {
  const pageContainer = document.querySelector('.page-container');
  if (pageContainer) {
    pageContainer.scrollTop = 0;
  }
};
